import React from 'react'
import { SupportResultReportContainer } from '../../containers/SupportSystem/SupportResultReportContainer'
export const SupportResultReportPage = () => {
  return (
    <SupportResultReportContainer/>
  )
}
